// Lucide icon: arrow-right (https://lucide.dev/icons/arrow-right)
import { ArrowRight } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconPointerRight = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ArrowRight />
    </IconComponentStyled>
  )
}
